// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero {
    background: linear-gradient(180deg, #f5f5f5 0%, #ffffff 100%);
    color: #1a1a1a;
    min-height: 100vh;
    padding: 60px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.hero-container {
    max-width: 800px;
    width: 100%;
    text-align: center;
}

.hero-logo {
    width: 200px;
    height: 200px;
    margin-bottom: 24px;
    object-fit: contain;
}

.hero-title {
    font-size: 2.8rem;
    font-weight: 700;
    margin-bottom: 12px;
    line-height: 1.1;
}

.hero-subtitle {
    font-size: 1.1rem;
    color: #666;
    margin-bottom: 40px;
}

.hero-caption {
    font-size: 0.9rem;
    color: #999;
    margin-bottom: 40px;
    line-height: 1.5;
}

.hero-description {
    font-size: 1rem;
    color: #555;
    margin-bottom: 60px;
    line-height: 1.6;
    padding: 0 20px;
}

.btn-large {
    width: 100%;
    max-width: 400px;
    padding: 16px 32px;
    font-size: 1.1rem;
    margin-bottom: 20px;
}

.features-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    margin-top: 60px;
}

.feature-card {
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 32px 24px;
    text-align: left;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
}

.feature-card:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
    border-color: #0077b5;
}

.feature-icon {
    font-size: 2.5rem;
    margin-bottom: 16px;
}

.feature-card h3 {
    font-size: 1.3rem;
    margin-bottom: 16px;
    color: #1a1a1a;
}

.feature-card ul {
    list-style: none;
    padding: 0;
    margin-bottom: 24px;
}

.feature-card li {
    font-size: 0.95rem;
    color: #666;
    padding: 8px 0;
    padding-left: 24px;
    position: relative;
}

.feature-card li:before {
    content: '•';
    position: absolute;
    left: 0;
    color: #0077b5;
    font-weight: bold;
}

.feature-card .btn-secondary {
    width: 100%;
    padding: 12px 16px;
}

@media (max-width: 768px) {
    .hero {
        padding: 40px 16px;
    }

    .hero-title {
        font-size: 2rem;
    }

    .features-grid {
        grid-template-columns: 1fr;
    }

    .hero-logo {
        font-size: 3rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Hero.css"],"names":[],"mappings":"AAAA;IACI,6DAA6D;IAC7D,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,yCAAyC;IACzC,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".hero {\n    background: linear-gradient(180deg, #f5f5f5 0%, #ffffff 100%);\n    color: #1a1a1a;\n    min-height: 100vh;\n    padding: 60px 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.hero-container {\n    max-width: 800px;\n    width: 100%;\n    text-align: center;\n}\n\n.hero-logo {\n    width: 200px;\n    height: 200px;\n    margin-bottom: 24px;\n    object-fit: contain;\n}\n\n.hero-title {\n    font-size: 2.8rem;\n    font-weight: 700;\n    margin-bottom: 12px;\n    line-height: 1.1;\n}\n\n.hero-subtitle {\n    font-size: 1.1rem;\n    color: #666;\n    margin-bottom: 40px;\n}\n\n.hero-caption {\n    font-size: 0.9rem;\n    color: #999;\n    margin-bottom: 40px;\n    line-height: 1.5;\n}\n\n.hero-description {\n    font-size: 1rem;\n    color: #555;\n    margin-bottom: 60px;\n    line-height: 1.6;\n    padding: 0 20px;\n}\n\n.btn-large {\n    width: 100%;\n    max-width: 400px;\n    padding: 16px 32px;\n    font-size: 1.1rem;\n    margin-bottom: 20px;\n}\n\n.features-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 24px;\n    margin-top: 60px;\n}\n\n.feature-card {\n    background: white;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    padding: 32px 24px;\n    text-align: left;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n    transition: all 0.3s ease;\n}\n\n.feature-card:hover {\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\n    border-color: #0077b5;\n}\n\n.feature-icon {\n    font-size: 2.5rem;\n    margin-bottom: 16px;\n}\n\n.feature-card h3 {\n    font-size: 1.3rem;\n    margin-bottom: 16px;\n    color: #1a1a1a;\n}\n\n.feature-card ul {\n    list-style: none;\n    padding: 0;\n    margin-bottom: 24px;\n}\n\n.feature-card li {\n    font-size: 0.95rem;\n    color: #666;\n    padding: 8px 0;\n    padding-left: 24px;\n    position: relative;\n}\n\n.feature-card li:before {\n    content: '•';\n    position: absolute;\n    left: 0;\n    color: #0077b5;\n    font-weight: bold;\n}\n\n.feature-card .btn-secondary {\n    width: 100%;\n    padding: 12px 16px;\n}\n\n@media (max-width: 768px) {\n    .hero {\n        padding: 40px 16px;\n    }\n\n    .hero-title {\n        font-size: 2rem;\n    }\n\n    .features-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .hero-logo {\n        font-size: 3rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
